import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React, { createContext, useContext, useMemo } from 'react';
import { useManyRefs } from '@carnica/utils/hooks';
import { useSortedMessages } from "./hooks";
var SessionContext = /*#__PURE__*/createContext({
  sessions: [],
  includedIds: [],
  refs: {}
});
export var SessionProvider = function SessionProvider(_ref) {
  var children = _ref.children,
    params = _objectWithoutProperties(_ref, _excluded);
  var _useSortedMessages = useSortedMessages(params),
    sessions = _useSortedMessages.sessions,
    ids = _useSortedMessages.ids,
    includedIds = _useSortedMessages.includedIds;
  var refs = useManyRefs(ids);
  var value = useMemo(function () {
    return {
      refs: refs,
      includedIds: includedIds,
      sessions: sessions
    };
  }, [sessions, ids, includedIds]);
  return /*#__PURE__*/React.createElement(SessionContext.Provider, {
    value: value
  }, children);
};
export var useSessionContext = function useSessionContext() {
  return useContext(SessionContext);
};